import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateHiringPDF = (post, companyData) => {
  const doc = new jsPDF();
  const marginLeft = 14;
  let currentY = 20;

  const overview = post.opportunityOverview;
  const role = post.roleDetails;
  const comp = post.compensationAndDates;
  const contact = post.contactInformation;

  const companyInfo = {
    companyName: companyData.companyName || '-',
    website: companyData.website || '-',
    aboutCompany: companyData.aboutCompany || '-',
  };

  const sectionTitleStyle = () => {
    doc.setFontSize(13);
    doc.setTextColor('#043885');
    doc.setFont('helvetica', 'bold');
  };

  const resetFontStyle = () => {
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.setFont('helvetica', 'normal');
  };

  const addSection = (title, body) => {
    sectionTitleStyle();
    doc.text(title, marginLeft, currentY);
    currentY += 6;
    resetFontStyle();

    autoTable(doc, {
      startY: currentY,
      head: [['Field', 'Details']],
      body,
      margin: { left : marginLeft, right : 14 },
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: {
        fillColor: [4, 56, 133],
        textColor: [255, 255, 255],
        halign: 'left',
      },
      alternateRowStyles: {
        fillColor: [240, 245, 255],
      },
    });

    currentY = doc.lastAutoTable.finalY + 10;
  };

  // Add header
  const addHeader = () => {
    doc.setFontSize(16);
    doc.setTextColor('#043885');
    doc.setFont('helvetica', 'bold');
    doc.text('Hiring Opportunity Details', marginLeft, 12);
    resetFontStyle();
  };

  // Add footer with page number
  const addFooter = () => {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 10);
    }
  };

  addHeader();

  addSection("SECTION 1: COMPANY DETAILS", [
    ['1. Company Name', companyInfo.companyName],
    ['2. Company Website', companyInfo.website],
    ['3. About the Company', companyInfo.aboutCompany],
  ]);

  addSection("SECTION 2: OPPORTUNITY OVERVIEW", [
    ['4. Opportunity Title', overview.title],
    ['5. Opportunity Type', overview.opportunityType],
    ['6. Number of Positions', overview.positions.toString()],
    ['7. Location', overview.location],
    ['8. Duration', overview.duration || '-'],
    ['9. Minimum Experience Required', overview.experience],
  ]);

  addSection("SECTION 3: ROLE DETAILS", [
    ['10. Domain / Functional Area', role.domain],
    ['11. Role Overview', role.roleOverview || '-'],
    ['12. Key Responsibilities / Tasks', role.responsibilities || '-'],
    ['13. Deliverables / Output Expectations', role.deliverables || '-'],
    ['14. Skill Requirements / Tools', role.skills?.join(', ') || '-'],
    ['15. Preferred Technical Background', role.preferredBackground || '-'],
  ]);

  addSection("SECTION 4: COMPENSATION & DATES", [
    ['16. Stipend / Salary', comp.stipendOrSalary || 'Unpaid'],
    ['17. Application Deadline', comp.applicationDeadline?.slice(0, 10) || '-'],
    ['18. Expected Joining Date', comp.joiningDate?.slice(0, 10) || '-'],
  ]);

  addSection("SECTION 5: CONTACT INFORMATION", [
    ['19. Contact Person Name', contact.contactName],
    ['20. Contact Email', contact.contactEmail],
    ['21. Contact Phone Number', contact.contactPhone],
    ['22. LinkedIn Profile (Optional)', contact.linkedInProfile || '-'],
  ]);

  addFooter();

  doc.save(`${overview.title}-HiringPost.pdf`);
};
